import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    scrollId: "noticecontainer "
  },
  mutations: {
  
    SET_scrollId(state,str) {
      state.scrollId = str
    }

  },
  actions: {},
  modules: {}
});
